/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * VSD API
 * API for the Victim Services Directory (VSD) application
 * OpenAPI spec version: v1
 */
import type {
  HttpResponse as AngularHttpResponse,
  HttpContext,
  HttpEvent,
  HttpHeaders,
  HttpParams
} from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import type {
  CVAPEmailResult,
  CityLookupDtoLookupResponseDto,
  CitySearchResponseDto,
  CountryLookupDtoLookupResponseDto,
  GetApiLookupCitiesSearchParams,
  LookupItemDtoLookupResponseDto,
  PoliceDetachmentLookupDtoLookupResponseDto,
  ProvinceLookupDtoLookupResponseDto,
  RelationshipLookupDtoLookupResponseDto
} from '../../model';

type HttpClientOptions = {
  headers?:
    | HttpHeaders
    | {
        [header: string]: string | string[];
      };
  context?: HttpContext;
  observe?: any;
  params?:
    | HttpParams
    | {
        [param: string]: string | number | boolean | ReadonlyArray<string | number | boolean>;
      };
  reportProgress?: boolean;
  responseType?: any;
  withCredentials?: boolean;
};

@Injectable({ providedIn: 'root' })
export class LookupService {
  constructor(private http: HttpClient) {}
  getApiLookupCvapEmails<TData = CVAPEmailResult>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  getApiLookupCvapEmails<TData = CVAPEmailResult>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  getApiLookupCvapEmails<TData = CVAPEmailResult>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  getApiLookupCvapEmails<TData = CVAPEmailResult>(options?: HttpClientOptions): Observable<TData> {
    return this.http.get<TData>(`/cvapwebform/api/Lookup/cvap-emails`, options);
  }
  getApiLookupCountries<TData = CountryLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  getApiLookupCountries<TData = CountryLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  getApiLookupCountries<TData = CountryLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  getApiLookupCountries<TData = CountryLookupDtoLookupResponseDto>(options?: HttpClientOptions): Observable<TData> {
    return this.http.get<TData>(`/cvapwebform/api/Lookup/countries`, options);
  }
  getApiLookupProvinces<TData = ProvinceLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  getApiLookupProvinces<TData = ProvinceLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  getApiLookupProvinces<TData = ProvinceLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  getApiLookupProvinces<TData = ProvinceLookupDtoLookupResponseDto>(options?: HttpClientOptions): Observable<TData> {
    return this.http.get<TData>(`/cvapwebform/api/Lookup/provinces`, options);
  }
  getApiLookupCities<TData = CityLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  getApiLookupCities<TData = CityLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  getApiLookupCities<TData = CityLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  getApiLookupCities<TData = CityLookupDtoLookupResponseDto>(options?: HttpClientOptions): Observable<TData> {
    return this.http.get<TData>(`/cvapwebform/api/Lookup/cities`, options);
  }
  getApiLookupCitiesSearch<TData = CitySearchResponseDto>(
    params?: GetApiLookupCitiesSearchParams,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  getApiLookupCitiesSearch<TData = CitySearchResponseDto>(
    params?: GetApiLookupCitiesSearchParams,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  getApiLookupCitiesSearch<TData = CitySearchResponseDto>(
    params?: GetApiLookupCitiesSearchParams,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  getApiLookupCitiesSearch<TData = CitySearchResponseDto>(
    params?: GetApiLookupCitiesSearchParams,
    options?: HttpClientOptions
  ): Observable<TData> {
    return this.http.get<TData>(`/cvapwebform/api/Lookup/cities/search`, {
      ...options,
      params: { ...params, ...options?.params }
    });
  }
  getApiLookupCountryCountryIdCities<TData = CityLookupDtoLookupResponseDto>(
    countryId: string,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  getApiLookupCountryCountryIdCities<TData = CityLookupDtoLookupResponseDto>(
    countryId: string,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  getApiLookupCountryCountryIdCities<TData = CityLookupDtoLookupResponseDto>(
    countryId: string,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  getApiLookupCountryCountryIdCities<TData = CityLookupDtoLookupResponseDto>(
    countryId: string,
    options?: HttpClientOptions
  ): Observable<TData> {
    return this.http.get<TData>(`/cvapwebform/api/Lookup/country/${countryId}/cities`, options);
  }
  getApiLookupCountryCountryIdProvinceProvinceIdCities<TData = CityLookupDtoLookupResponseDto>(
    countryId: string,
    provinceId: string,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  getApiLookupCountryCountryIdProvinceProvinceIdCities<TData = CityLookupDtoLookupResponseDto>(
    countryId: string,
    provinceId: string,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  getApiLookupCountryCountryIdProvinceProvinceIdCities<TData = CityLookupDtoLookupResponseDto>(
    countryId: string,
    provinceId: string,
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  getApiLookupCountryCountryIdProvinceProvinceIdCities<TData = CityLookupDtoLookupResponseDto>(
    countryId: string,
    provinceId: string,
    options?: HttpClientOptions
  ): Observable<TData> {
    return this.http.get<TData>(`/cvapwebform/api/Lookup/country/${countryId}/province/${provinceId}/cities`, options);
  }
  getApiLookupRelationships<TData = RelationshipLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  getApiLookupRelationships<TData = RelationshipLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  getApiLookupRelationships<TData = RelationshipLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  getApiLookupRelationships<TData = RelationshipLookupDtoLookupResponseDto>(
    options?: HttpClientOptions
  ): Observable<TData> {
    return this.http.get<TData>(`/cvapwebform/api/Lookup/relationships`, options);
  }
  getApiLookupAuthRelationships<TData = RelationshipLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  getApiLookupAuthRelationships<TData = RelationshipLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  getApiLookupAuthRelationships<TData = RelationshipLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  getApiLookupAuthRelationships<TData = RelationshipLookupDtoLookupResponseDto>(
    options?: HttpClientOptions
  ): Observable<TData> {
    return this.http.get<TData>(`/cvapwebform/api/Lookup/auth_relationships`, options);
  }
  getApiLookupRepresentativeRelationships<TData = RelationshipLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  getApiLookupRepresentativeRelationships<TData = RelationshipLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  getApiLookupRepresentativeRelationships<TData = RelationshipLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  getApiLookupRepresentativeRelationships<TData = RelationshipLookupDtoLookupResponseDto>(
    options?: HttpClientOptions
  ): Observable<TData> {
    return this.http.get<TData>(`/cvapwebform/api/Lookup/representative_relationships`, options);
  }
  getApiLookupImfRepresentativeRelationships<TData = RelationshipLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  getApiLookupImfRepresentativeRelationships<TData = RelationshipLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  getApiLookupImfRepresentativeRelationships<TData = RelationshipLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  getApiLookupImfRepresentativeRelationships<TData = RelationshipLookupDtoLookupResponseDto>(
    options?: HttpClientOptions
  ): Observable<TData> {
    return this.http.get<TData>(`/cvapwebform/api/Lookup/imf_representative_relationships`, options);
  }
  getApiLookupPoliceDetachments<TData = PoliceDetachmentLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  getApiLookupPoliceDetachments<TData = PoliceDetachmentLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  getApiLookupPoliceDetachments<TData = PoliceDetachmentLookupDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  getApiLookupPoliceDetachments<TData = PoliceDetachmentLookupDtoLookupResponseDto>(
    options?: HttpClientOptions
  ): Observable<TData> {
    return this.http.get<TData>(`/cvapwebform/api/Lookup/police_detachments`, options);
  }
  getApiLookupCourts<TData = LookupItemDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'body' }
  ): Observable<TData>;
  getApiLookupCourts<TData = LookupItemDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'response' }
  ): Observable<AngularHttpResponse<TData>>;
  getApiLookupCourts<TData = LookupItemDtoLookupResponseDto>(
    options?: Omit<HttpClientOptions, 'observe'> & { observe?: 'events' }
  ): Observable<HttpEvent<TData>>;
  getApiLookupCourts<TData = LookupItemDtoLookupResponseDto>(options?: HttpClientOptions): Observable<TData> {
    return this.http.get<TData>(`/cvapwebform/api/Lookup/courts`, options);
  }
}

export type GetApiLookupCvapEmailsClientResult = NonNullable<CVAPEmailResult>;
export type GetApiLookupCountriesClientResult = NonNullable<CountryLookupDtoLookupResponseDto>;
export type GetApiLookupProvincesClientResult = NonNullable<ProvinceLookupDtoLookupResponseDto>;
export type GetApiLookupCitiesClientResult = NonNullable<CityLookupDtoLookupResponseDto>;
export type GetApiLookupCitiesSearchClientResult = NonNullable<CitySearchResponseDto>;
export type GetApiLookupCountryCountryIdCitiesClientResult = NonNullable<CityLookupDtoLookupResponseDto>;
export type GetApiLookupCountryCountryIdProvinceProvinceIdCitiesClientResult =
  NonNullable<CityLookupDtoLookupResponseDto>;
export type GetApiLookupRelationshipsClientResult = NonNullable<RelationshipLookupDtoLookupResponseDto>;
export type GetApiLookupAuthRelationshipsClientResult = NonNullable<RelationshipLookupDtoLookupResponseDto>;
export type GetApiLookupRepresentativeRelationshipsClientResult = NonNullable<RelationshipLookupDtoLookupResponseDto>;
export type GetApiLookupImfRepresentativeRelationshipsClientResult =
  NonNullable<RelationshipLookupDtoLookupResponseDto>;
export type GetApiLookupPoliceDetachmentsClientResult = NonNullable<PoliceDetachmentLookupDtoLookupResponseDto>;
export type GetApiLookupCourtsClientResult = NonNullable<LookupItemDtoLookupResponseDto>;
